// 公共交互边界：只读、整轮阻断、忙碌和过期时禁止发送动作。新增组件不得绕过此约束。
import { componentSupport } from '@/ai/protocol/component-support'
import AiNotice from '../AiCompatibilityNotice.vue'
import AiIcon from '@/components/common/icons/AiIcon.vue'
export default {
 components: { AiIcon, AiNotice },
 props: {card:Object,blocked:Boolean,busy:Boolean,actionBusy:Boolean,pagination:{type:Object,default:()=>({})},readOnly:Boolean,now:Number},
 computed: {
  known() { return componentSupport(this.card) !== 'unsupported' },
  expired() { return this.card.interaction && Date.parse(this.card.interaction.expiresAt) <= this.now },
  disabled() { return this.readOnly || this.blocked || this.busy || this.expired }
 },
 methods: {
    send(kind, input) {
      if (this.card.interaction && Date.parse(this.card.interaction.expiresAt) <= Date.now()) return
      if (!this.disabled) this.$emit('action', { card: this.card, kind, input })
    }
 }
}
